import React from 'react';
import styles from './loadingCard.scss';

const LoadingCard = ({ 'data-testid': dataTestId }) => {
    return (
        <div className={`${styles.loadingCard}`} data-testid={dataTestId}>
            <div className={`${styles.loadingCardDetails}`}>
                <div className={`${styles.tagContainer} ${styles.loadingAnimation}`} />
                <div className={`${styles.emptyDiv}`} />
                <div className={`${styles.name} ${styles.loadingAnimation}`} />
                <div className={`${styles.detailsContainer} ${styles.loadingAnimation}`} />
            </div>
        </div>
    );
};

export default LoadingCard;
